import { render, staticRenderFns } from "./AlertBar.vue?vue&type=template&id=2c040dcc&scoped=true"
import script from "./AlertBar.vue?vue&type=script&lang=js"
export * from "./AlertBar.vue?vue&type=script&lang=js"
import style0 from "./style.scss?vue&type=style&index=0&id=2c040dcc&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c040dcc",
  null
  
)

export default component.exports